import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: '',
        code: ''
      },
      rules: {
        code: [{
          required: true,
          message: "请输入礼包码",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.copyPrimitive();

                  _this.formData.id = data;

                  _this.copyData();
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var data = JSON.parse(JSON.stringify(_this2.formData));

                    _this2.$api.activeGiftCode({
                      student_id: data.id,
                      code: data.code
                    }).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success("手动激活成功!");

                        _this2.$emit('change');

                        _this2.dialogFormVisible = false;
                      } else {
                        _this2.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};